/**
 * Whether the chat widget is shown.
 *
 * Signed-in personal (個人) customers only: the business team decided to
 * release the chatbot to them first (PPS-389). `is_business_account` is
 * always a boolean once the profile has loaded, so checking for `false`
 * also keeps the widget hidden while the profile is still loading -- a 法人
 * customer never sees it flash on screen.
 *
 * `showWithoutLogin` is the local-only escape hatch (see MainLayout).
 */
export const canShowChatbot = ({ isNotPublicPage, token, profile, showWithoutLogin = false }) =>
    showWithoutLogin || (Boolean(isNotPublicPage && token) && profile?.is_business_account === false);
